import { CheckoutAddress } from '../Filter/FilterEventHelper'
import { CreateSortParams } from '../../events/sort/SortAppliedEvent'

interface SortCategoryMap {
  [key: string]: string
}

export const createSortAppliedEventParams = (
  sortLabel: string,
  checkoutAddress: CheckoutAddress
): CreateSortParams => {
  const sortCategoryMap: SortCategoryMap = {
    'Relevancy': 'relevance',
    'Newest': 'newest',
    'Price: Low to high': 'price_asc',
    'Price: High to low': 'price_desc',
    'Brand: A-Z': 'a-z',
    'Brand: Z-A': 'z-a',
  }

  const sortCategory = sortCategoryMap[sortLabel] || sortLabel.toLowerCase()

  return {
    SORT_CATEGORY: sortCategory,
    STORE_ID_DBP: checkoutAddress?.storeId?.toString() || null,
    STORE_ID_SAP: checkoutAddress?.clientId?.toString() || null,
  }
}
